export default "__VITE_ASSET__lO6VWiAK__"